import { Checkbox, Collapse, Select, Space, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import { selectedViews } from "../../constant/table";
import { GREEN, LIGHT_BLUE, NEW_BLUE, GRAY5, WHITE } from "../../constant/colors";
import { MultiSelect } from "../customComponent/CustomSelect";
import { DateRangeFilter } from "../filter/DateRangeFilter";
import { ALL_TIMES, FILTER_CLAIM_ASSIGNEE, FILTER_CLAIM_LAST_SAVED_BY } from "../../constant/filters";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAssigneesAndUserGroups,
  selectFilters,
  selectFiltersInputs,
  selectProvidersFacility,
  selectSelectedView
} from "../../store/selector";
import ACTIONS from "../../store/action";
import { searchRxnormDrugsAPI } from "../../api/api";
import { useTranslation } from "react-i18next";
import { statuses } from "../../constant/claim";
import { MultiSelectDrugSearch } from "@tailormed/common-client/component/MultiSelectDrugSearch";
import { filterSort } from "../../utils/sort";
import { formatAssignee } from "../../utils/formaters";
const { Text, Title } = Typography;
const { Panel } = Collapse;
const { Option } = Select;

const CLAIM_ASSIGNEE = "claimAssignee";
const CLAIM_LAST_SAVED_BY = "claimLastSavedBy";

export const ClaimFiltersPanel = ({
  handleInputMultiSelect,
  handleInputDate,
  resetDatesToDefault,
  filtersVisible,
  assigneesTextToDisplay,
  validAssignees,
  handleUnassignedToggle
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dates, multiples } = useSelector(selectFilters);
  const filters = useSelector(selectFilters);
  const filtersInputs = useSelector(selectFiltersInputs);
  const selectedView = useSelector(selectSelectedView);
  const facilities = useSelector(selectProvidersFacility);
  const assignees = useSelector(selectAssigneesAndUserGroups);

  const setFiltersInputs = (filterName, value) => dispatch(ACTIONS.setFiltersInputs(filterName, value));
  const setFiltersAct = (filters) => dispatch(ACTIONS.setFiltersAction(filters));

  const [isClaimDrugNameSelectOpen, setIsClaimDrugNameSelectOpen] = useState(false);
  const [isClaimDrugNameSelectHover, setIsClaimDrugNameSelectHover] = useState(false);
  const [facilitySearchInput, setFacilitySearchInput] = useState("");
  const [claimAssigneesSearchInput, setClaimAssigneesSearchInput] = useState("");
  const [claimLastSavedBySearchInput, setClaimLastSavedBySearchInput] = useState("");
  const { claimDate, dateOfService, claimFollowupDate, claimSubmittedDate, claimReceivedDate, claimLastSavedDate } =
    dates;

  const isClaimsFiltersActive = () => {
    const claimStatus = filtersInputs.claimStatuses;
    const claimDate = dates.claimDate.value;
    const claimFollowupDate = dates.claimFollowupDate.value;
    const claimSubmittedDate = dates.claimSubmittedDate.value;
    const claimReceivedDate = dates.claimReceivedDate.value;
    const claimLastSavedDateValue = dates?.claimLastSavedDate?.value;
    const claimRxnormDrugs = filtersInputs.claimRxnormDrugs;
    const claimFacilities = filtersInputs.claimFacilities;
    const claimServiceDate = dates.dateOfService.value;
    const claimAssignee = filtersInputs.claimAssignee;
    const claimLastSavedBy = filtersInputs.claimLastSavedBy;
    const isUnassignedClaim = filtersInputs.isUnassignedClaim;

    if (
      claimStatus.length > 0 ||
      claimDate !== ALL_TIMES ||
      claimFollowupDate !== ALL_TIMES ||
      claimSubmittedDate !== ALL_TIMES ||
      claimReceivedDate !== ALL_TIMES ||
      claimLastSavedDateValue !== ALL_TIMES ||
      claimServiceDate !== ALL_TIMES ||
      claimRxnormDrugs.length > 0 ||
      claimFacilities.length > 0 ||
      claimAssignee?.length > 0 ||
      claimLastSavedBy?.length > 0 ||
      !!isUnassignedClaim
    ) {
      return true;
    }
  };

  const searchRxnormDrugs = async (searchTerm) => {
    const response = await searchRxnormDrugsAPI({ text: searchTerm });
    return response?.data?.rxnormDrugs || [];
  };

  const handleSelectedDrugsChange = (selectedDrugs) => {
    setFiltersInputs("claimRxnormDrugs", selectedDrugs);

    setFiltersAct({
      ...filters,
      multiples: { ...multiples, claimRxnormDrugs: selectedDrugs }
    });
  };

  const claimDrugNameTextToDisplay =
    (filtersInputs.claimRxnormDrugs &&
      filtersInputs.claimRxnormDrugs.length > 0 &&
      filtersInputs.claimRxnormDrugs.map(({ tmDisplayName }) => tmDisplayName).join(" | ")) ||
    "";

  return (
    selectedView === selectedViews.allClaims && (
      <Collapse ghost expandIconPosition="end" style={{ display: !filtersVisible ? "none" : undefined }}>
        <Panel
          header={
            <Title level={5} style={{ color: NEW_BLUE }}>
              {t("tableFilters.claims")}
              {isClaimsFiltersActive() && (
                <div
                  style={{
                    position: "absolute",
                    background: GREEN,
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    left: "247px",
                    top: "24px"
                  }}
                />
              )}
            </Title>
          }
        >
          <Space size={16} direction="vertical" style={{ width: "100%" }}>
            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_status")}
              </Text>
              <MultiSelect
                id="filter_claim_status"
                onChange={(values, options) => handleInputMultiSelect(values, options, "claimStatuses")}
                value={filtersInputs.claimStatuses}
                tooltipContent={Object.values(multiples.claimStatuses || {})}
                autoClearSearchValue={false}
                mode="multiple"
                maxTagCount={1}
                maxTagTextLength={filtersInputs.claimStatuses.length > 1 ? 8 : 16}
                allowClear={true}
                style={{ width: "100%" }}
                placeholder={t("all")}
                bordered={false}
              >
                {statuses.map((status) => {
                  return (
                    <Option key={status.value} value={status.value}>
                      {status.label}
                    </Option>
                  );
                })}
              </MultiSelect>
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_assignee")}
              </Text>
              <MultiSelect
                id={FILTER_CLAIM_ASSIGNEE}
                tooltipContent={assigneesTextToDisplay(CLAIM_ASSIGNEE)}
                onChange={(values, options) => handleInputMultiSelect(values, options, CLAIM_ASSIGNEE)}
                disabled={filtersInputs.isUnassignedClaim}
                value={!validAssignees(CLAIM_ASSIGNEE) ? [] : validAssignees(CLAIM_ASSIGNEE).map(({ id }) => id)}
                autoClearSearchValue={false}
                showSearch
                mode="multiple"
                maxTagCount={1}
                maxTagTextLength={filtersInputs.claimAssignee?.length > 1 ? 8 : 16}
                allowClear
                style={{ width: "100%" }}
                placeholder={filtersInputs.isUnassignedClaim ? t("unassigned") : `${t("all")}`}
                filterOption={(input, option) => {
                  setClaimAssigneesSearchInput(input.toLowerCase());
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
                filterSort={(a, b) => {
                  const aIsSelected = filtersInputs.claimAssignee?.indexOf(a.value) > -1;
                  const bIsSelected = filtersInputs.claimAssignee?.indexOf(b.value) > -1;
                  if ((aIsSelected && bIsSelected) || (!aIsSelected && !bIsSelected)) {
                    return a.children.localeCompare(b.children);
                  }
                  if (aIsSelected && !bIsSelected) {
                    return -1;
                  }
                  if (!aIsSelected && bIsSelected) {
                    return 1;
                  }
                }}
                bordered={false}
                onSelectAll={() => {
                  const filteredAssignees = assignees.filter((d) =>
                    d.displayName?.toLowerCase().includes(claimAssigneesSearchInput)
                  );
                  const values = filteredAssignees.map(({ id }) => id);
                  const options = assignees.map(({ id, displayName, name }, index) => ({
                    value: id,
                    key: index,
                    children: displayName || name
                  }));

                  handleInputMultiSelect(values, options, CLAIM_ASSIGNEE);
                }}
                onClearAll={() => {
                  handleInputMultiSelect([], [], CLAIM_ASSIGNEE);
                  setClaimAssigneesSearchInput("");
                }}
                selectAll
                clearAll
              >
                {assignees.map(({ id, firstName, lastName, name, type }) => (
                  <Option key={id} value={id}>
                    {formatAssignee({ firstName, lastName, name, type })}
                  </Option>
                ))}
              </MultiSelect>

              <Space id="claim_filter_unassignee">
                <Checkbox
                  style={{ paddingTop: 4 }}
                  checked={filtersInputs.isUnassignedClaim}
                  onChange={(e) => handleUnassignedToggle("isUnassignedClaim", CLAIM_ASSIGNEE, e.target.checked)}
                  id="claim_unassignee_checkbox"
                >
                  <Text style={{ color: LIGHT_BLUE }}>{t("unassigned")}</Text>
                </Checkbox>
              </Space>
            </Space>

            <Space style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_location")}
              </Text>
              <MultiSelect
                id="filter_claim_facilities"
                dropdownMatchSelectWidth={false}
                onChange={(values, options) => handleInputMultiSelect(values, options, "claimFacilities")}
                value={filtersInputs.claimFacilities}
                tooltipContent={Object.values(multiples.claimFacilities || {})}
                autoClearSearchValue={false}
                showSearch
                mode="multiple"
                maxTagCount={1}
                maxTagTextLength={filtersInputs.claimFacilities?.length > 1 ? 8 : 16}
                allowClear
                style={{ width: "100%" }}
                placeholder={`${t("all")}`}
                filterOption={(input, option) => {
                  setFacilitySearchInput(input.toLowerCase());
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
                filterSort={filterSort}
                bordered={false}
                clearAll={true}
                selectAll={true}
                onSelectAll={() => {
                  const filteredFacilities = facilities.filter((d) =>
                    d.name?.toLowerCase().includes(facilitySearchInput)
                  );
                  const values = filteredFacilities.map(({ id }) => id);
                  const options = facilities.map(({ id, name }, index) => ({
                    value: id,
                    key: index,
                    children: name
                  }));
                  handleInputMultiSelect(values, options, "claimFacilities");
                }}
                onClearAll={() => {
                  handleInputMultiSelect([], [], "claimFacilities");
                  setFacilitySearchInput("");
                }}
              >
                {facilities?.map((facility, index) => (
                  <Option key={index} value={facility.id} localSortKey={facility.name}>
                    {facility.name}
                  </Option>
                ))}
              </MultiSelect>
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_date")}
              </Text>
              <DateRangeFilter
                id="filter_claim_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("claimDate", value)}
                onSelect={(fromDate, toDate, value = null) => handleInputDate(fromDate, toDate, "claimDate", value)}
                allowClear={true}
                onClear={() => {
                  resetDatesToDefault("claimDate", ALL_TIMES);
                }}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="claimDateFilters"
                timeRange={claimDate}
              />
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_follow_up_date")}
              </Text>
              <DateRangeFilter
                id="filter_claim_follow_up_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("claimFollowupDate", value)}
                onSelect={(fromDate, toDate, value = null) =>
                  handleInputDate(fromDate, toDate, "claimFollowupDate", value)
                }
                allowClear={true}
                onClear={() => {
                  resetDatesToDefault("claimFollowupDate", ALL_TIMES);
                }}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="claimFollowupDateFilters"
                timeRange={claimFollowupDate}
              />
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_submitted_date")}
              </Text>
              <DateRangeFilter
                id="filter_claim_submitted_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("claimSubmittedDate", value)}
                onSelect={(fromDate, toDate, value = null) =>
                  handleInputDate(fromDate, toDate, "claimSubmittedDate", value)
                }
                allowClear={true}
                onClear={() => {
                  resetDatesToDefault("claimSubmittedDate", ALL_TIMES);
                }}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="claimSubmittedDateFilters"
                timeRange={claimSubmittedDate}
              />
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.date_of_service")}
              </Text>
              <DateRangeFilter
                id="filter_claim_date_of_Service"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("dateOfService", value)}
                onSelect={(fromDate, toDate, value = null) => handleInputDate(fromDate, toDate, "dateOfService", value)}
                allowClear={true}
                onClear={() => {
                  resetDatesToDefault("dateOfService", ALL_TIMES);
                }}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="dateOfServiceFilters"
                timeRange={dateOfService}
              />
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_received_date")}
              </Text>
              <DateRangeFilter
                id="filter_claim_received_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("claimReceivedDate", value)}
                onSelect={(fromDate, toDate, value = null) =>
                  handleInputDate(fromDate, toDate, "claimReceivedDate", value)
                }
                allowClear={true}
                onClear={() => {
                  resetDatesToDefault("claimReceivedDate", ALL_TIMES);
                }}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="claimReceivedDateFilters"
                timeRange={claimReceivedDate}
              />
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_last_saved_date")}
              </Text>
              <DateRangeFilter
                id="filter_claim_last_saved_date"
                handleInput={(value = ALL_TIMES) => setFiltersInputs("claimLastSavedDate", value)}
                onSelect={(fromDate, toDate, value = null) =>
                  handleInputDate(fromDate, toDate, "claimLastSavedDate", value)
                }
                allowClear={true}
                onClear={() => {
                  resetDatesToDefault("claimLastSavedDate", ALL_TIMES);
                }}
                defaultValue={ALL_TIMES}
                placeHolder={t(ALL_TIMES)}
                dateFilters="claimLastSavedDateFilters"
                timeRange={claimLastSavedDate || { fromDate: null, toDate: null, value: ALL_TIMES }}
              />
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_last_saved_by")}
              </Text>
              <MultiSelect
                id={FILTER_CLAIM_LAST_SAVED_BY}
                tooltipContent={assigneesTextToDisplay(CLAIM_LAST_SAVED_BY)}
                onChange={(values, options) => handleInputMultiSelect(values, options, CLAIM_LAST_SAVED_BY)}
                value={
                  !validAssignees(CLAIM_LAST_SAVED_BY) ? [] : validAssignees(CLAIM_LAST_SAVED_BY).map(({ id }) => id)
                }
                autoClearSearchValue={false}
                showSearch
                mode="multiple"
                maxTagCount={1}
                maxTagTextLength={filtersInputs.claimLastSavedBy?.length > 1 ? 8 : 16}
                allowClear
                style={{ width: "100%" }}
                placeholder={`${t("all")}`}
                filterOption={(input, option) => {
                  setClaimLastSavedBySearchInput(input.toLowerCase());
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
                filterSort={(a, b) => {
                  const aIsSelected = filtersInputs.claimLastSavedBy?.indexOf(a.value) > -1;
                  const bIsSelected = filtersInputs.claimLastSavedBy?.indexOf(b.value) > -1;
                  if ((aIsSelected && bIsSelected) || (!aIsSelected && !bIsSelected)) {
                    return a.children.localeCompare(b.children);
                  }
                  if (aIsSelected && !bIsSelected) {
                    return -1;
                  }
                  if (!aIsSelected && bIsSelected) {
                    return 1;
                  }
                }}
                bordered={false}
                onSelectAll={() => {
                  const usersOnly = assignees.filter((d) => d.type !== "user-group");
                  const filteredAssignees = usersOnly.filter((d) =>
                    d.displayName?.toLowerCase().includes(claimLastSavedBySearchInput)
                  );
                  const values = filteredAssignees.map(({ id }) => id);
                  const options = usersOnly.map(({ id, displayName, name }, index) => ({
                    value: id,
                    key: index,
                    children: displayName || name
                  }));

                  handleInputMultiSelect(values, options, CLAIM_LAST_SAVED_BY);
                }}
                onClearAll={() => {
                  handleInputMultiSelect([], [], CLAIM_LAST_SAVED_BY);
                  setClaimLastSavedBySearchInput("");
                }}
                selectAll
                clearAll
              >
                {assignees
                  .filter(({ type }) => type !== "user-group")
                  .map(({ id, firstName, lastName, name, type }) => (
                    <Option key={id} value={id}>
                      {formatAssignee({ firstName, lastName, name, type })}
                    </Option>
                  ))}
              </MultiSelect>
            </Space>

            <Space size={0} style={{ width: "100%" }} direction="vertical">
              <Text strong style={{ color: LIGHT_BLUE }}>
                {t("tableFilters.claim_drug_name")}
              </Text>
              <Tooltip
                open={claimDrugNameTextToDisplay && !isClaimDrugNameSelectOpen && isClaimDrugNameSelectHover}
                title={<Text>{claimDrugNameTextToDisplay}</Text>}
                color={WHITE}
                placement="right"
                overlayStyle={{
                  maxWidth: "calc(100% - 600px)",
                  whiteSpace: "normal",
                  wordWrap: "break-word"
                }}
              >
                <MultiSelectDrugSearch
                  id="filter_claim_drug_name"
                  searchRxnormDrugs={searchRxnormDrugs}
                  mode="multiple"
                  placeholder={t("all")}
                  onChangeSelectedDrugs={(selectedDrugs) => handleSelectedDrugsChange(selectedDrugs)}
                  onClear={() => handleSelectedDrugsChange([])}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  value={filtersInputs.claimRxnormDrugs}
                  displayNameMaxChars={25}
                  bordered={false}
                  style={{
                    width: "100%",
                    border: `0px`,
                    borderBottom: `1px solid ${GRAY5}`,
                    padding: 0
                  }}
                  onDropdownVisibleChange={(open) => setIsClaimDrugNameSelectOpen(open)}
                  onMouseEnter={() => setIsClaimDrugNameSelectHover(true)}
                  onMouseLeave={() => setIsClaimDrugNameSelectHover(false)}
                  maxTagCount={1}
                  maxTagTextLength={filtersInputs.rxnormDrugs.length == 1 ? 15 : 6}
                />
              </Tooltip>
            </Space>
          </Space>
        </Panel>
      </Collapse>
    )
  );
};
